import { ValueTransformer } from 'typeorm'

/** Typeorm values transformer that transforms JSON arrays */
export class JSONArrayTransformer<T> implements ValueTransformer {
	to(data: T[]): string {
		return JSON.stringify(data)
	}

	from(data: string): T[] {
		return JSON.parse(data)
	}
}
